import React, { useState, useContext } from 'react';
import { StudentContext } from '../StudentContext';
import { addNewStudent , fetchStudentCount } from '../GoogleSheetsService';
import './AddNewStudent.css';

// Utility function to remove Vietnamese diacritics
const removeDiacritics = (str) => {
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D');
};

// Utility function to generate initials
const getInitials = (fullName) => {
  const words = fullName.trim().split(/\s+/);
  return words.map(word => removeDiacritics(word[0])).join('').toUpperCase();
};

const AddNewStudent = () => {
  const { allBlocks } = useContext(StudentContext);
  const [holyName, setHolyName] = useState('');
  const [fullName, setFullName] = useState('');
  const [className, setClassName] = useState('');
  const [dateOfBirth, setDateOfBirth] = useState('');
  const [modalVisible, setModalVisible] = useState(false);
  const [submittedData, setSubmittedData] = useState(null);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!holyName || !fullName || !className || !dateOfBirth) {
      setError('Vui lòng điền đầy đủ thông tin.');
      return;
    }

    try {
      // Fetch student count for ID generation
      const studentCount = await fetchStudentCount(); // To be implemented in GoogleSheetsService.js
      const initials = getInitials(fullName);
      const newId = `AN-${initials}-${studentCount + 2}`;

      const studentData = {
        id: newId,
        holyName,
        fullName,
        className,
        dateOfBirth,
      };

      const response = await addNewStudent(studentData);
      if (response.success) {
        setSubmittedData(studentData);
        setModalVisible(true);
        // Reset form
        setHolyName('');
        setFullName('');
        setClassName('');
        setDateOfBirth('');
      } else {
        setError(response.message || 'Lỗi khi thêm thiếu nhi.');
      }
    } catch (err) {
      setError('Lỗi khi thêm thiếu nhi: ' + err.message);
    }
  };

  const closeModal = () => {
    setModalVisible(false);
    setSubmittedData(null);
  };

  return (
    <div className="add-new-student-container admin-container">
      <h2>Thêm Thiếu Nhi Mới</h2>
      {error && <p className="error">{error}</p>}
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Tên Thánh</label>
          <input
            type="text"
            value={holyName}
            onChange={(e) => setHolyName(e.target.value)}
            placeholder="Nhập Tên Thánh"
          />
        </div>
        <div className="form-group">
          <label>Họ và Tên</label>
          <input
            type="text"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            placeholder="Nhập Họ và Tên"
          />
        </div>
        <div className="form-group">
          <label>Lớp</label>
          <select
            value={className}
            onChange={(e) => setClassName(e.target.value)}
          >
            <option value="">Chọn lớp</option>
            {Object.values(allBlocks).flat().map((classItem) => (
              <option key={classItem.id} value={classItem.name}>
                {classItem.name}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label>Ngày Sinh</label>
          <input
            type="date"
            value={dateOfBirth}
            onChange={(e) => setDateOfBirth(e.target.value)}
          />
        </div>
        <button type="submit" className="submit-button">
          Thêm Thiếu Nhi
        </button>
      </form>

      {modalVisible && submittedData && (
        <div className="modal">
          <div className="modal-content">
            <h3>Thiếu Nhi Đã Được Thêm</h3>
            <p><strong>ID:</strong> {submittedData.id}</p>
            <p><strong>Tên Thánh:</strong> {submittedData.holyName}</p>
            <p><strong>Họ và Tên:</strong> {submittedData.fullName}</p>
            <p><strong>Lớp:</strong> {submittedData.className}</p>
            <p><strong>Ngày Sinh:</strong> {submittedData.dateOfBirth}</p>
            <button onClick={closeModal}>Đóng</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddNewStudent;